/**
 * RLS-silent-update guard.
 *
 * A PostgREST UPDATE that RLS filters out returns no error and simply
 * touches 0 rows, so a save looks successful while nothing was written.
 * Callers add `.select('id')` to the update and pass the returned rows here:
 * zero rows means the user may not change that record/field.
 */

export const NO_PERMISSION_MESSAGE =
  "You don't have permission to change this field";

export function assertRowsUpdated(
  rows: readonly unknown[] | null | undefined,
  message: string = NO_PERMISSION_MESSAGE
): void {
  if (!rows || rows.length === 0) {
    throw new Error(message);
  }
}
